import { Alert, Button, Skeleton, Tooltip } from 'antd';
import { getColor, Heading4 } from '@lib/common';
import styled from 'styled-components';
import { Panel } from './class-dashboard.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var STUDENT_OVERVIEW_METRICS = ['total', 'notStarted', 'inProgress', 'submitted', 'overdue', 'banned'];
var StudentOverview = styled(Panel).withConfig({
  displayName: "class-student-overviewcomponent__StudentOverview",
  componentId: "sc-16hizfi-0"
})([".overview-metrics{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:16px;}.overview-metric{padding:16px;border-radius:12px;background:", ";border:1px solid ", ";}.overview-metric strong{display:block;font-size:26px;color:", ";}.overview-metric span{color:", ";}@media (max-width:1000px){.overview-metrics{grid-template-columns:repeat(3,minmax(0,1fr));}}@media (max-width:600px){.overview-metrics{grid-template-columns:repeat(2,minmax(0,1fr));}}"], getColor('fillBgWhite'), getColor('fillIntSubActive'), getColor('fillIntActive'), getColor('contentBody'));
export function ClassStudentOverviewPanel(_ref) {
  var resource = _ref.resource,
      onRetry = _ref.onRetry,
      labels = _ref.labels;
  return /*#__PURE__*/_jsxs(StudentOverview, {
    children: [/*#__PURE__*/_jsx(Heading4, {
      children: labels.title
    }), resource.error ? /*#__PURE__*/_jsx(Alert, {
      type: "error",
      showIcon: true,
      message: labels.error,
      description: resource.error,
      action: /*#__PURE__*/_jsx(Button, {
        onClick: onRetry,
        children: labels.retry
      })
    }) : resource.loading || !resource.data ? /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }) : /*#__PURE__*/_jsx("div", {
      className: "overview-metrics",
      children: STUDENT_OVERVIEW_METRICS.map(function (key) {
        return /*#__PURE__*/_jsxs("div", {
          className: "overview-metric",
          children: [/*#__PURE__*/_jsx("strong", {
            children: resource.data.counts[key]
          }), /*#__PURE__*/_jsx("span", {
            children: key === 'overdue' ? /*#__PURE__*/_jsx(Tooltip, {
              title: labels.overdueHint,
              children: labels.metrics[key]
            }) : labels.metrics[key]
          })]
        }, key);
      })
    })]
  });
}